/* eslint-disable */

export enum SausageStyleColor {
  Pink = "SAUSAGE_COLOR_PINK",
  Blue = "SAUSAGE_COLOR_BLUE",
  Yellow = "SAUSAGE_COLOR_YELLOW",
  Green = "SAUSAGE_COLOR_GREEN",
  Purple = "SAUSAGE_COLOR_PURPLE",
}

export enum Color {
  Blue = "enum-color-blue",
  DarkBlue = "enum-color-dark-blue",
  Green = "enum-color-green",
  Purple = "enum-color-purple",
  Yellow = "enum-color-yellow",
  Red = "enum-color-red",
  Bronze = "enum-color-bronze",
  Silver = "enum-color-silver",
  Gold = "enum-color-gold",
  Raindrop = "enum-color-raindrop",
}

export enum Orientation {
  Portrait,
  Landscape,
}

export enum Size {
  Small,
  Medium,
  Large,
  Huge,
}

export enum AppTheme {
  Light,
  Dark,
  System,
}

export enum QuestionState {
  Correct = "correct",
  Incorrect = "incorrect",
  NotAnswered = "not-answered",
}
